// KVK Service for validating Dutch Chamber of Commerce numbers

export const validateKvkNumber = async (kvkNumber) => {
  // Clean the KVK number (remove spaces, dashes, etc.)
  const cleanKvkNumber = kvkNumber.replace(/[\s-]/g, '');

  // Basic format validation (Dutch KVK numbers are 8 digits)
  if (!/^\d{8}$/.test(cleanKvkNumber)) {
    return {
      isValid: false,
      error: 'KVK nummer moet 8 cijfers bevatten'
    };
  }

  return {
    isValid: true,
    kvkNumber: cleanKvkNumber,
    note: 'Alleen gecontroleerd op formaat (8 cijfers).'
  };
}; 